import { toast } from '@affine/component';
import type { DemoContentRemovedEvent } from '@affine/nbstore';
import { type Observable, throttleTime } from 'rxjs';

import { demoContentRemovedNotice } from './demo-name-error';

/** Uses the same toast facility as NotificationServiceImpl. */
export function bindDemoContentRemovedNotice(
  events$: Observable<DemoContentRemovedEvent>
) {
  return events$.pipe(throttleTime(3000)).subscribe(() => {
    toast(demoContentRemovedNotice());
  });
}
